module.exports = __webpack_public_path__ + "static/media/arrow-top-left.de370825.svg";